// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G3KOb","label":"styles_label__-TQ1p"};